import Component from 'gia/Component';
import { gsap } from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      mobileMenu: {},
      buttonOpenMenu: {},
      buttonCloseMenu: {},
      headerInner: {},
      links: [],
      submenus: [],
      menuWrapper: {},
      headerBackground: {},
      headerMobile: {},
      closeMobile: {},
      openMobile: {},
      rencontronsFormWrapper: {},
      rencontronsForm: {},
      closeRencontronsForm: {},
      openRencontronsForm: {},
      mobileItem: [],
      globe: {},
      switcher: {},
      blackLogo: []
    };
  }

  mount() {
    let that = this;

// Activate for multi language
    // this.ref.globe.addEventListener('click', function(e) {
    //   if (that.ref.globe.classList.contains('active')) {
    //     that.ref.globe.classList.remove('active');
    //
    //     gsap.to(that.ref.switcher, {
    //       width: '0', onComplete: function() {
    //         that.ref.switcher.classList.add('hidden');
    //       }
    //     });
    //   } else {
    //     that.ref.globe.classList.add('active');
    //     that.ref.switcher.classList.remove('hidden');
    //     gsap.to(that.ref.switcher, {width: 'auto'});
    //   }
    // })

    // this.ref.closeRencontronsForm.addEventListener('click', function(e) {
    //
    //   gsap.to(that.ref.rencontronsFormWrapper, {
    //     opacity: '0', duration: 0.5, onComplete: function() {
    //       that.ref.rencontronsFormWrapper.classList.add('hidden');
    //     }
    //   });
    // })
    //
    // this.ref.openRencontronsForm.addEventListener('click', function(e) {
    //   that.ref.rencontronsFormWrapper.classList.remove('hidden');
    //   gsap.to(that.ref.rencontronsFormWrapper, {
    //     opacity: '1', duration: 0.5, onStart: function() {
    //       that.ref.rencontronsFormWrapper.classList.remove('hidden');
    //     }
    //   });
    // })


    this.ref.openMobile.addEventListener('click', function(e) {
      gsap.to(that.ref.headerMobile, {
        x: '0', duration: 0.5, onComplete: function() {
          gsap.to(that.ref.mobileItem, {opacity: 1, duration: 0.8, stagger: 0.1})
        }
      });
    })
    this.ref.closeMobile.addEventListener('click', function(e) {
      gsap.to(that.ref.headerMobile, {
        x: '100%', duration: 0.5, onComplete: function() {
          gsap.to(that.ref.mobileItem, {opacity: 0, duration: 0});
        }
      });
    })

    this.ref.links.forEach(function(link, index) {
      link.addEventListener('mouseenter', function(e) {
        let submenu = that.ref.submenus[index];
        that.showSub(index);
      });
      link.addEventListener('mouseleave', function(e) {
        let submenu = that.ref.submenus[index];
        console.log(e.relatedTarget);
        if (e.relatedTarget != submenu && e.relatedTarget != that.ref.menuWrapper) {
          // submenu.classList.add('hidden');
          that.hideSub(index);
        }
      });
    });


    this.ref.submenus.forEach(function(submenu, index) {
      submenu.addEventListener('mouseleave', function(e) {
        // e.target.classList.add('hidden');
        that.hideSub(index);
      });
    });


    const showAnim1 = gsap.timeline({ // Create a timelne
      scrollTrigger: {
        id: "max",
        start: () => 0, // current window times 1.5 eg 150vh
        end: "max",
        onUpdate: (self) => {
          self.direction === 1 ? showAnim1.play() : showAnim1.reverse();
        }
      }
    });


    showAnim1.to(this.ref.headerBackground, {
      y: '-100%'
    })

    let tl = gsap.timeline({
      yoyo: true,
      scrollTrigger: {
        trigger: 'body',
        start: "200px top",         // fires when scroll hits 80px
        end: "200px top",
        toggleActions: "play none none reverse",

      }
    })
    tl.fromTo(this.ref.headerBackground, {top: "30px"}, {top: "0px", duration: 0.5});
    tl.fromTo(this.ref.headerBackground, {backgroundColor: "rgba(0,0,0,0)", "--tw-backdrop-blur": "blur(0px)"}, {backgroundColor: "rgba(0,0,0,0.2)", "--tw-backdrop-blur": "blur(24px)", duration: 0.5});
    tl.fromTo(this.ref.headerBackground, {"--menu-text": "inherit"}, {"--menu-text": "#ffffff", duration: 0.5},'-=0.5');
    tl.fromTo(this.ref.blackLogo, {opacity: 1}, {opacity: 0, duration: 0.5},'-=0.5');

  }

  showSub(index) {
    this.ref.submenus[index].classList.remove('hidden');
    gsap.to(this.ref.submenus[index], {opacity: 1, duration: 0.3});
  }

  hideSub(index) {
    let that = this;
    gsap.to(this.ref.submenus[index], {
      opacity: 0, duration: 0.3, onComplete: function() {
        that.ref.submenus[index].classList.add('hidden');
      }
    });
  }


}